<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Filter Accounts</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content>
  <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
    <mat-label>Subscription</mat-label>
    <mat-select [(ngModel)]="filter_options.subscription" matTooltip="Filter accounts by subscription." name="subscription">
      <mat-option value="">All</mat-option>
      <mat-option *ngFor="let subscription of app.getSubscriptions()" [value]="subscription">{{ subscription }}</mat-option>
    </mat-select>
    <mat-hint>Use this to filter accounts by subscription.</mat-hint>
  </mat-form-field>

  <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
    <mat-label>Account Type</mat-label>
    <mat-select [(ngModel)]="filter_options.account_type" matTooltip="Filter accounts by type." name="account_type">
      <mat-option value="">All</mat-option>
      <mat-option value="internal">Internal</mat-option>
      <mat-option value="client">Client</mat-option>
    </mat-select>
    <mat-hint>Filter by internal or client accounts.</mat-hint>
  </mat-form-field>

  <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
    <mat-label>SMS Notifications</mat-label>
    <mat-select [(ngModel)]="filter_options.sms_notifications" matTooltip="Filter accounts by SMS notification state." name="sms_notifications">
      <mat-option value="">All</mat-option>
      <mat-option value="enabled">Enabled</mat-option>
      <mat-option value="disabled">Disabled</mat-option>
    </mat-select>
    <mat-hint>Filter by whether SMS notifications are enabled.</mat-hint>
  </mat-form-field>

  <div class="full-width mb-3">
    <button mat-stroked-button type="button" class="full-width" (click)="onSelectAssociatedUsers()">
      <mat-icon>people</mat-icon>
      Associated Users<span *ngIf="filter_options.associated_users.length"> ({{ filter_options.associated_users.length }})</span>
    </button>
    <mat-hint>Only show accounts these user(s) are linked to.</mat-hint>
  </div>

  <div class="full-width mb-3">
    <mat-checkbox [(ngModel)]="filter_options.include_merged_accounts" matTooltip="When enabled, merged accounts will be included in the list of results." name="include_merged_accounts">
      Include "Merged" Accounts.
    </mat-checkbox>
    <mat-hint>When enabled, merged accounts will be included in the list of results.</mat-hint>
  </div>

  <div class="full-width">
    <mat-checkbox [(ngModel)]="filter_options.include_personal_accounts" matTooltip="When enabled, users' personal accounts will be included in the list of results." name="include_personal_accounts">
      Include Personal Accounts.
    </mat-checkbox>
    <mat-hint>
      Personal accounts are created for users who are waiting to be approved into a company account, and
      are named after the person. They are hidden by default.
    </mat-hint>
  </div>
</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex justify-content-center my-2 py-2">
  <div class="p-2">
    <button type="button" mat-raised-button color="primary" (click)="onSaveAndClose()">
      <mat-icon>filter_list</mat-icon> Apply Filter
    </button>
  </div>
  <div class="p-2">
    <button type="button" mat-raised-button color="secondary" (click)="onClearAndClose()">
      <mat-icon> clear_all</mat-icon> Clear Filter
    </button>
  </div>
</mat-dialog-actions>
